module.exports = __webpack_public_path__ + "img/宝山区报名地点.af48e99c.png";